import { CxEvent } from '@spartacus/core';

export class FbqGgProductPageEvent extends CxEvent {
  event?: string;
}
